package br.com.vvrefeicoes.portal.domain.model

data class Permission(
    val id: String,
)
